import React from 'react';
import PageLayout from '../../SharedComponents/PageLayout';

const RealTimeMapView = (): JSX.Element => <PageLayout title="Operations / Realtime View">Map</PageLayout>;

export default RealTimeMapView;
